import { EmailTemplateRegularMode } from "./regular-mode";

export const EmailTemplateComposeTab = () => {
  return <EmailTemplateRegularMode />;
};
